import React, { useState } from 'react';
import Joyride, { Step, CallBackProps } from 'react-joyride';
import { Button } from 'primereact/button';

interface TutorialProps {
  steps: Step[];
}

const ScorecardTutorial: React.FC<TutorialProps> = ({ steps }) => {
  const [run, setRun] = useState(false);

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data;
    const finishedStatuses: string[] = ['finished', 'skipped'];

    if (finishedStatuses.includes(status)) {
      setRun(false);
    }
  };

  return (
    <>
      <Button 
        icon="pi pi-question-circle" 
        rounded 
        label="Help"
        aria-label="Help" 
        onClick={() => setRun(true)} 
        tooltip="Show help"
        tooltipOptions={{ position: 'right' }}
        style={{
          zIndex: 1000,
          marginLeft: "12px",
        }}
      />
      <Joyride
        steps={steps}
        run={run}
        callback={handleJoyrideCallback}
        continuous
        showProgress
        showSkipButton
        styles={{
          options: {
            arrowColor: '#e3fffd',
            backgroundColor: '#e3fffd',
            overlayColor: 'rgb(103, 103, 103)',
            primaryColor: '#000',
            textColor: '#004a14',
            width: 900,
            zIndex: 1000,
          }
        }}
      />
    </>
  );
};

export default ScorecardTutorial; 